import { render, staticRenderFns } from "./HeaderProfitabilityAnalysis.vue?vue&type=template&id=20193692&scoped=true"
import script from "./HeaderProfitabilityAnalysis.vue?vue&type=script&lang=js"
export * from "./HeaderProfitabilityAnalysis.vue?vue&type=script&lang=js"
import style0 from "./HeaderProfitabilityAnalysis.vue?vue&type=style&index=0&id=20193692&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20193692",
  null
  
)

export default component.exports